/*
  单个用户积分的数据内容
*/
import { Credits } from '@/api'
import { Notify } from 'vant'

export default {
  state: {
    total: null,
    addedToday: null,
    drawedToday: false,
    nextType: undefined
  },
  mutations: {
    GET_CREDITS (state, credits) {
      ['total', 'addedToday', 'drawedToday', 'nextType'].forEach(key => {
        state[key] = credits[key]
      })
    }
  },
  actions: {
    async updateCredits ({ commit }) {
      try {
        const { credits } = await Credits.update()
        Notify({
          type: 'success',
          message: '领取积分成功'
        })
        commit('GET_CREDITS', credits)
      } catch (error) {
        console.log(error)
      }
    },
    async checkCredits ({ commit }) {
      try {
        const { credits } = await Credits.check()
        commit('GET_CREDITS', credits)
      } catch (error) {
        console.log(error)
      }
    }
  }
}
